import { memo, useCallback } from "react";

import CustomInput from "../../CustomInput/CustomInput";

import InputList from "../../InputList/InputList";

interface Props {
  id: string;
  list: string[];
  required: boolean;
  history?: boolean | undefined;
  dynamicRows?: boolean;
  tag: string;
}

const TextAreaList = (props: Props) => {
  const renderInput = useCallback(
    (id: string, index: number, value: any) => (
      <CustomInput w="100%" id={`${id}.${index}.text`} value={value} textarea />
    ),
    [],
  );

  return (
    <InputList
      {...props}
      dynamicRows={props.dynamicRows ?? false}
      renderInput={renderInput}
    />
  );
};

export default memo(TextAreaList);
